import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { distinctUntilChanged, debounceTime, catchError } from 'rxjs/operators';
import { AuthGuardService } from './auth-guard.service';
@Injectable({
    providedIn: 'root',
})
export class PeakworkService {
    constructor(
        private http: HttpClient,
        private authGuardService: AuthGuardService,
    ) { }

    request(obj, suffix: string): Observable<any> {
        obj.partnerid = this.authGuardService.getPartnerId();
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'ngsw-bypass': '',
            })
        };
        return this.http.post('api/peakwork/' + suffix, { body: obj }, httpOptions)
            .pipe(
                debounceTime(50),
                distinctUntilChanged(),
                catchError(res => of(res))
            );
    }
}
